/* unplugin-vue-components disabled */import { render } from "./ReferenceTable1.vue?vue&type=template&id=617f70f2&scoped=true&ts=true"
import script from "./ReferenceTable1.vue?vue&type=script&lang=ts"
export * from "./ReferenceTable1.vue?vue&type=script&lang=ts"

import "./ReferenceTable1.vue?vue&type=style&index=0&id=617f70f2&scoped=true&lang=less"
import "./ReferenceTable1.vue?vue&type=style&index=1&id=617f70f2&lang=css"

import exportComponent from "/home/jenkins/agent/workspace/yunxiaobao-test/prod-huodada-com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-617f70f2"]])

export default __exports__